export const NO_GATEWAY = 'No Gateway';
export const BLACKHAWK = 'Blackhawk';
export const EPAY = 'epay';
export const INCOMM = 'InComm';
